import React, { forwardRef } from "react";
import styled from "styled-components";
import { styleTheme } from "../../../style/theme";
import { getPrimaryColor } from "../../../style/utils";

import { CheckBoxPropsType } from "./CheckBox.types";

const Component = forwardRef<HTMLInputElement, CheckBoxPropsType>(
  ({ checkStyle = "outline", ...props }, ref) => (
    <label className={props.className} htmlFor={props.id}>
      <input type="checkbox" ref={ref} {...props} />
      <span className="checkbox-icon"></span>
      {props.linkURL && props.linkText && (
        <a href={props.linkURL} target="_blank" rel="noreferrer">
          {props.linkText}
        </a>
      )}
      {props.label}
      {props.required && <span className="required"> *</span>}
    </label>
  )
);

export const CheckBox: React.FC<CheckBoxPropsType> = styled(
  Component
)<CheckBoxPropsType>`
  align-items: flex-end;
  color: ${styleTheme.colors.black};
  cursor: pointer;
  display: inline-flex;
  gap: 8px;

  > input {
    height: 0;
    position: absolute;
    width: 0;
    opacity: 0;

    &:hover + span {
      border: 1px solid ${getPrimaryColor};
    }

    &:focus + span {
      border: 1px solid ${styleTheme.colors.teal.base};
      outline: 1px solid ${styleTheme.colors.teal.base};
    }

    &:checked + span {
      background: ${(props) =>
        props.checkStyle === "fill"
          ? getPrimaryColor
          : styleTheme.colors.white};
      border: 1px solid
        ${(props) =>
          props.checkStyle === "fill"
            ? getPrimaryColor
            : styleTheme.colors.gray.base};

      &::after {
        border-bottom: 3px solid
          ${(props) =>
            props.checkStyle === "fill"
              ? styleTheme.colors.white
              : getPrimaryColor};
        border-left: 3px solid
          ${(props) =>
            props.checkStyle === "fill"
              ? styleTheme.colors.white
              : getPrimaryColor};
        content: "";
        display: block;
        height: 7px;
        left: 0;
        position: absolute;
        top: 2px;
        transform: rotate(-45deg);
        width: 14px;
      }
    }
  }

  > input + span {
    background: ${styleTheme.colors.white};
    border: 1px solid ${styleTheme.colors.gray.base};
    display: inline-block;
    height: 16px;
    position: relative;
    width: 16px;
    border-radius: 2px;
  }

  > .checkbox-icon {
    flex-shrink: 0;
  }

  > .required {
    color: red;
  }
`;
